
export default [
  {
    path:"/bridge",
    meta: {
      title: "Bridge",
      icon: "",
    },
    component: () => import('@/views/transfer/index'),
  }


]
